import isNil from 'lodash/isNil';
import { arrayOf, bool, func } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import getInfoTooltip from '../../../generic/Tooltip/get-info-tooltip';
import { campaignShape, productShape } from '../../../prop-types';
import { tapFlashError, tapFlashSuccess } from '../../../utils/flash';
import { addBookingEntry as addBookingEntryAction } from '../../actions/booking-entry-actions';
import HELP_TEXTS from '../../help-texts';
import { generateBookingEntriesFromCampaignLines } from '../../utils';

class GenerateNonMediaBookingEntriesButton extends Component {
  state = { loading: false };

  handleOnClick = async () => {
    const { campaign, products, addBookingEntry } = this.props;

    this.setState({ loading: true });
    tapFlashSuccess('Generating non media booking entries...')();

    try {
      const bookingEntries = generateBookingEntriesFromCampaignLines(
        campaign,
        products,
      );

      if (bookingEntries.length) {
        await Promise.all(bookingEntries.map(entry => addBookingEntry(entry)));
        tapFlashSuccess(
          'Successfully generated all non media booking entries',
        )();
      } else {
        throw new Error(
          "There aren't any non-media campaign-lines for this campaign",
        );
      }
    } catch (e) {
      tapFlashError()(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { campaign, disabled } = this.props;
    const { loading } = this.state;

    const isDisabled = loading || isNil(campaign) || disabled;

    return (
      <Button
        className="ml-2"
        disabled={isDisabled}
        onClick={this.handleOnClick}
      >
        Generate Non Media Entries{' '}
        {getInfoTooltip(
          HELP_TEXTS,
          'generateNonMediaEntries',
          'actionButtons',
          'top',
        )}
      </Button>
    );
  }
}

GenerateNonMediaBookingEntriesButton.propTypes = {
  campaign: campaignShape,
  products: arrayOf(productShape.isRequired).isRequired,
  addBookingEntry: func.isRequired,
  disabled: bool,
};

GenerateNonMediaBookingEntriesButton.defaultProps = {
  campaign: null,
  disabled: false,
};

export default connect(null, {
  addBookingEntry: addBookingEntryAction,
})(GenerateNonMediaBookingEntriesButton);
